import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

export default function ModernSearchInput({value, onChange, label, clearLabel, className = "", compact = false}) {
    const inputSizeClassName = compact ? "py-2 pl-3 pr-9 text-xs" : "py-2.5 pl-4 pr-11 text-sm";
    const clearButtonSizeClassName = compact ? "w-9 text-xs" : "w-11";

    return (
        <div className={`relative ${className}`}>
            <input
                type="search"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder={label}
                aria-label={label}
                className={`w-full min-w-0 rounded-lg border border-slate-300 bg-white text-slate-800 shadow-none outline-none transition placeholder:text-slate-400 focus:border-violet-500 focus:ring-0 focus:shadow-none dark:border-slate-600 dark:bg-slate-900 dark:text-slate-100 ${inputSizeClassName}`}
            />
            {value && <button
                type="button"
                onClick={() => onChange("")}
                aria-label={clearLabel}
                title={clearLabel}
                className={`absolute inset-y-0 right-0 inline-flex items-center justify-center text-slate-400 transition hover:text-slate-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-violet-400 dark:text-slate-500 dark:hover:text-slate-200 ${clearButtonSizeClassName}`}
            >
                <FontAwesomeIcon icon={faXmark}/>
            </button>}
        </div>
    );
}
